<ng-select
  #select
  class="ag-budget-activity-dropdown w-full"
  [ngClass]="{
    'show-placeholder': formControl.value === '',
  }"
  [formControl]="formControl"
  [items]="params.options"
  [clearable]="formControl.value"
  [searchable]="true"
  groupBy="path"
  bindLabel="label"
  bindValue="value"
  appendTo="body"
  [placeholder]="'Select budget activity'"
  (change)="onChange()"
>
  <ng-template ng-optgroup-tmp let-item="item" let-index="index">
    @for (
      title of getCategoryTitles(item.path);
      track title;
      let first = $first;
      let last = $last
    ) {
      <div
        #textGroup
        class="truncate"
        [ngClass]="{ 'pt-2': !first, 'pb-2': !last }"
        [ngStyle]="{ 'padding-left': title.level * 12 + 'px' }"
        [auxTooltip]="textGroup.offsetWidth < textGroup.scrollWidth ? title.name : ''"
      >
        {{ title.name }}
      </div>
    }
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="item">
    <div
      #text
      class="truncate"
      [ngStyle]="{ 'padding-left': item.categories.length * 12 + 'px' }"
      [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
      auxTooltipPanelContainerClass="ag-budget-activity-dropdown-tooltip"
    >
      {{ item.label }}
    </div>
  </ng-template>
</ng-select>
